import styled from 'styled-components';
import { breakpoints } from '../../../../../assets/styles/GlobalStyles';

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  gap: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

export const CheckboxProgressContainer = styled.div.attrs(props => ({
  style: {
    background: props.$allChecked ? '#f0fdf4' : '#fef3c7',
    borderColor: props.$allChecked ? '#bbf7d0' : '#fde68a'
  }
}))`
  border: 1px solid;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const CheckboxProgressBar = styled.div`
  background: #e2e8f0;
  border-radius: 20px;
  height: 8px;
  width: 200px;
  max-width: 100%;
  flex: 1 1 120px;
  overflow: hidden;
`;

export const CheckboxProgressFill = styled.div.attrs(props => ({
  style: {
    background: props.$allChecked ? '#22c55e' : '#eab308',
    width: `${props.$percent}%`
  }
}))`
  height: 100%;
  transition: width 0.3s ease;
`;

// Âncora de cada campo do formulário: o FormStep localiza o campo pelo
// data-field-name para rolar/focar/tremer (ver utils/destaqueCampos.js).
export const FieldWrapper = styled.div`
  min-width: 0;
  scroll-margin-top: 6rem;
`;
